import React, { useEffect, useState, Fragment } from "react";
import Layout from "../Components/Reuseable/layout";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import Cookies from "js-cookie";
import { Accordion } from "react-bootstrap";
import "../../Webiste/Components/CSS/pagesCSS/dashboard.css";
import ScrollContainer from "react-indiana-drag-scroll";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import Select from "react-select";
import Pagination from "./Pagination";
import "../Components/CSS/RaceCardCSS/racecard.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchOwnerStatsPage } from "../redux/getReducer/getOwnerStats";
import { fetchOwnerRecord } from "../redux/getReducer/getOwnerRecord";
import Moment from "react-moment";
import { IoIosArrowDropdownCircle, IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight } from "react-icons/md";
import PleaseWait from "../Components/Reuseable/PleaseWait";
import arrow1 from "../assets/image 13 (Traced).png";
import { truncateRaceType, formatDateStandard, toTitleCase } from "../service/stringUtils";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { fetchResultYearFilterForStats } from "../redux/getStatsFilterReduce/getResultYearFilterForStats";
import { fetchRaceTypeFilterForStats } from "../redux/getStatsFilterReduce/getRaceTypeFilterForStats";
import { fetchTrackLengthFilterForStats } from "../redux/getStatsFilterReduce/getTrackLengthFilterForStats";
import { fetchHorseKindFilterForStats } from "../redux/getStatsFilterReduce/getHorseKindFilterForStats";
import { fetchRaceKindFilterForStats } from "../redux/getStatsFilterReduce/getRaceKindFilterForStats";
import { fetchRaceNationalityFilterForStats } from "../redux/getStatsFilterReduce/getRaceNationalityFilterForStats";
import { fetchRaceCourseFilterForStats } from "../redux/getStatsFilterReduce/getRaceCourseFilterForStats";
import { fetchDatesFilterForStats } from "../redux/getStatsFilterReduce/getDatesFilterForStats";
import { fetchGroundTypeFilterForStats } from "../redux/getStatsFilterReduce/getGroundTypeFilterForStats";

import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import TrainerModal from "../Components/Modal/TrainerModal";
import JockeyModal from "../Components/Modal/JockeyModal";
import HorseModal from "../Components/Modal/HorseModal";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import VideoFrame from "../Components/Modal/VideoFrame";
import RaceModal from "../Components/Modal/RaceModal";
import ExNews from "../Components/Home/Components/ExNews";
import Search from "../Components/Home/Components/Search";
import Notification from "../Components/Home/Components/Notification";
import Language from "../Components/Home/Components/Language";

const { RangePicker } = DatePicker;

export default function Trainerstatistics() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cookiedata = Cookies.get("i18next");

  // SELECTORS
  const { data: OwnerStatsPage, status } = useSelector((state) => state.OwnerStatsPage);
  const { data: Ownerrecord, statusdata } = useSelector((state) => state.Ownerrecord);
  const { data: ResultYearFilterForStats } = useSelector((state) => state.ResultYearFilterForStats);
  const { data: RaceTypeFilterForStats } = useSelector((state) => state.RaceTypeFilterForStats);
  const { data: TrackLengthFilterForStats } = useSelector((state) => state.TrackLengthFilterForStats);
  const { data: HorseKindFilterForStats } = useSelector((state) => state.HorseKindFilterForStats);
  const { data: RaceKindFilterForStats } = useSelector((state) => state.RaceKindFilterForStats);
  const { data: RaceNationalityFilterForStats } = useSelector((state) => state.RaceNationalityFilterForStats);
  const { data: RaceCourseFilterForStats } = useSelector((state) => state.RaceCourseFilterForStats);
  const { data: GroundTypeFilterForStats } = useSelector((state) => state.GroundTypeFilterForStats);

  // STATES
  const [showBody, setShowBody] = useState(null);
  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const [showHorse, setShowHorse] = useState(false);
  const [modaldataHorse, setmodaldataHorse] = useState();
  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const [showJockey, setShowJockey] = useState(false);
  const [modaldataJockey, setmodaldataJockey] = useState();

  const [StartDate, setStartDate] = useState(moment().subtract(179, "days").format("YYYY-MM-DD"));
  const [EndDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(11);
  let totalcountdata = OwnerStatsPage ? OwnerStatsPage.totalcount : "";
  let totalpagesdata = OwnerStatsPage ? OwnerStatsPage.totalPages : "";

  const [ResultYearData, setResultYearData] = useState("");
  const [ResultRaceCourseData, setResultRaceCourse] = useState("");
  const [ResultNationalityData, setResultNationality] = useState("");
  const [ResultRaceTracklengthData, setResultRaceTracklength] = useState("");
  const [ResultGroundData, setResultGround] = useState("");
  const [ResultRaceKindData, setResultRaceKind] = useState("");
  const [ResultHorseKindData, setResultHorseKind] = useState("");
  const [ResultRaceTypeData, setResultRaceType] = useState("");

  // SCOPED VARIABLES FOR EFFECTS
  let year = ResultYearData?.id;
  let Nationality = ResultNationalityData?.id;
  let RaceCourse = ResultRaceCourseData?.id;
  let GroundType = ResultGroundData?.id;
  let RaceKind = ResultRaceKindData?.id;
  let HorseKind = ResultHorseKindData?.id;
  let RaceType = ResultRaceTypeData?.id;
  let TrackLength = ResultRaceTracklengthData?.id;

  let RaceCourseSearch = RaceCourse || "";
  let HorseKindSearch = HorseKind || "";
  let TrackLengthSearch = TrackLength || "";
  let RaceTypeSearch = RaceType || "";
  let RaceKindSearch = RaceKind || "";
  let RaceNationalitySearch = Nationality || "";
  let RaceGroundSearch = GroundType || "";

  // HANDLERS
  const handleClose = () => setShow(false);
  const handleShow = (data) => { const id = data?._id || data; if (id) navigate("/owner-detail?" + id); };
  const handleShowHorse = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => { setmodaldatas(data); await setShows(true); };
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };
  const handleCloseJockey = () => setShowJockey(false);
  const handleShowJockey = (data) => { const id = data?._id || data; if (id) navigate("/jockey-detail?" + id); };

  const handleDateChange = (dates, dateStrings) => {
    if (!dates || !dateStrings) {
      setStartDate("");
      setEndDate("");
      return;
    }
    setStartDate(dateStrings[0]);
    setEndDate(dateStrings[1]);
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // useEffect(() => {
  //   const selectedYear = ResultYearData?.id;
  //   if (!selectedYear) {
  //     setStartDate(moment().subtract(179, "days").format("YYYY-MM-DD"));
  //     setEndDate(moment().format("YYYY-MM-DD"));
  //     return;
  //   }

  //   const startOfYear = moment(`${selectedYear}-01-01`, "YYYY-MM-DD");
  //   const endOfYear = moment(`${selectedYear}-12-31`, "YYYY-MM-DD");
  //   const today = moment();

  //   let start = startOfYear;
  //   let end = endOfYear.isAfter(today, "day") ? today : endOfYear;

  //   if (end.isBefore(start, "day")) start = end.clone();

  //   setStartDate(start.format("YYYY-MM-DD"));
  //   setEndDate(end.format("YYYY-MM-DD"));
  // }, [ResultYearData]);

  useEffect(() => {
    dispatch(fetchOwnerStatsPage({ RaceCourseSearch, StartDate, EndDate, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceNationalitySearch, RaceGroundSearch, currentPage }));
  }, [dispatch, RaceCourseSearch, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceNationalitySearch, RaceGroundSearch, currentPage, StartDate, EndDate]);

  useEffect(() => {
    // dispatch(fetchResultYearFilterForStats({ year, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceTypeFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchTrackLengthFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchHorseKindFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceKindFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceNationalityFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceCourseFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    // dispatch(fetchDatesFilterForStats({ year, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchGroundTypeFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
  }, [dispatch, StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength]);

  const handleTrainerRecord = async (ownerId, index) => {
    setShowBody(index);
    const id = ownerId?._id || ownerId;
    await dispatch(fetchOwnerRecord({ id, StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
  };

  function distanceLabel(distance, rank) {
    const DistanceTobeChecked = parseFloat(distance);
    if (DistanceTobeChecked.toFixed(2) > 25) return "Dist";
    else if (DistanceTobeChecked.toFixed(2) == 0.05 && rank < 80) return "SHd";
    else if (DistanceTobeChecked.toFixed(2) == 0.1 && rank < 80) return "Hd";
    else if (DistanceTobeChecked.toFixed(2) == 0.25 && rank < 80) return "Nk";
    else if (DistanceTobeChecked.toFixed(2) == 0.01 && rank < 80) return "Ns";
    else if (DistanceTobeChecked.toFixed(2) == 0.0 && rank < 80) return rank === 1 ? 0 : "Dh";
    else return distance;
  }



  // DROPDOWN MAPPINGS
  let RaceYearDropdown = ResultYearFilterForStats.map(item => ({ id: item.RacesYear, value: item.RacesYear, label: item.RacesYear }));
  let NationalityDropdown = RaceNationalityFilterForStats.map(item => ({ id: item?.NationalityDataRaceCourse?._id, value: cookiedata === "en" ? item.NationalityDataRaceCourse?.NameEn : item?.NationalityDataRaceCourse?.NameAr, label: cookiedata === "en" ? item?.NationalityDataRaceCourse?.NameEn : item?.NationalityDataRaceCourse?.NameAr }));
  let RaceCourseDropdown = RaceCourseFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.TrackNameEn : item.TrackNameAr, label: cookiedata === "en" ? item.TrackNameEn : item.TrackNameAr }));
  let GroundTypeDropdown = GroundTypeFilterForStats?.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let RaceTypeDropdown = RaceTypeFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let TrackLengthDropdown = TrackLengthFilterForStats.map(item => ({ id: item._id, value: item.TrackLength, label: item.TrackLength }));
  let HorseKindDropdown = HorseKindFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let RaceKindDropdown = RaceKindFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#0c1a3e',
      border: 'none',
      borderRadius: '8px',
      minHeight: '44px',
      color: 'white',
      marginBottom: '0',
      cursor: 'pointer',
      boxShadow: 'none'
    }),
    singleValue: (provided) => ({ ...provided, color: 'white' }),
    placeholder: (provided) => ({ ...provided, color: '#9da7be', fontSize: '13px' }),
    dropdownIndicator: (provided) => ({ ...provided, color: 'white' }),
    indicatorSeparator: () => ({ display: 'none' }),
    clearIndicator: (provided) => ({ ...provided, color: '#fff', padding: '0 8px' }),
    valueContainer: (provided) => ({ ...provided, padding: '2px 8px', overflow: 'hidden' }),
    input: (provided) => ({ ...provided, margin: 0, padding: 0, opacity: 0 }),
    menu: (provided) => ({ ...provided, backgroundColor: '#0c1a3e', zIndex: 9999 }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isFocused ? '#2173d1' : '#0c1a3e', color: 'white', fontSize: '13px', cursor: 'pointer' })
  };


  return (
    <Fragment>
      <div className="new-owner-stats-page-wrapper">
        <div className="common-page-banner"><h1>{t("Owner Statistics")}</h1></div>

        <div className="new-owner-main-card-container">
          <div className="new-owner-filter-section-card">
            <div className="new-owner-dropdown-flex-row">
              <div className="new-owner-range-item">
                <style>{`.new-custom-range-picker input::placeholder { color: #9da7be !important; -webkit-text-fill-color: #9da7be !important; opacity: 1 !important; }`}</style>
                <RangePicker
                  value={[
                    StartDate ? dayjs(StartDate, "YYYY-MM-DD") : null,
                    EndDate ? dayjs(EndDate, "YYYY-MM-DD") : null,
                  ]}
                  onChange={handleDateChange}
                  format="YYYY-MM-DD"
                  className="new-custom-range-picker"
                  placeholder={[t("Start Date"), t("End Date")]}
                  separator={<span style={{ color: '#9da7be' }}>To</span>}
                  allowClear
                />
              </div>
              <Select styles={customSelectStyles} placeholder={t("Nationality")} options={NationalityDropdown} onChange={setResultNationality} className="new-owner-flex-item" isClearable />
              <Select styles={customSelectStyles} placeholder={t("Race course")} options={RaceCourseDropdown} onChange={setResultRaceCourse} className="new-owner-flex-item" isClearable />
              <Select styles={customSelectStyles} placeholder={t("Ground Type")} options={GroundTypeDropdown} onChange={setResultGround} className="new-owner-flex-item" isClearable />
            </div>
            <div className="new-owner-search-date-row">
              <Select styles={customSelectStyles} placeholder={t("Race Kind")} options={RaceKindDropdown} onChange={setResultRaceKind} className="new-owner-flex-item" isClearable />
              <Select styles={customSelectStyles} placeholder={t("KindOfHorse")} options={HorseKindDropdown} onChange={setResultHorseKind} className="new-owner-flex-item" isClearable />
              <Select styles={customSelectStyles} placeholder={t("Track length")} options={TrackLengthDropdown} onChange={setResultRaceTracklength} className="new-owner-flex-item" isClearable />
              <Select styles={customSelectStyles} placeholder={t("Race Type")} options={RaceTypeDropdown} onChange={setResultRaceType} className="new-owner-flex-item" isClearable />
            </div>
          </div>

          <div className="new-owner-stats-table-box">
            {status === "idle" ? (
              <>
                <div className="new-owner-main-thead">
                  <div>{window.textTransform(t("Owner Name"))}</div><div>{window.textTransform(t("Runs"))}</div><div>{window.textTransform(t("Wins"))}</div><div>{window.textTransform(t("Second"))}</div><div>{window.textTransform(t("Third"))}</div><div>{window.textTransform(t("Fourth"))}</div><div>{window.textTransform(t("Fifth"))}</div><div>{window.textTransform(t("Earning"))}</div><div>{window.textTransform(t("Wins"))}%</div><div>{window.textTransform(t("Place"))}%</div><div></div>
                </div>
                {OwnerStatsPage?.data?.map((item, index) => (
                  <Accordion key={index} className="new-owner-stats-accordion-wrapper">
                    <Accordion.Item eventKey={index} className="new-owner-acc-item" onClick={() => handleTrainerRecord(item.OwnerId, index)}>
                      <Accordion.Header className="new-owner-acc-header-custom">
                        <div className="new-owner-acc-header-grid">
                          <div className="new-owner-td-main-link" onClick={(e) => { e.stopPropagation(); handleShow(item.OwnerId); }}>{cookiedata === "en" ? window.textTransform(item.OwnerIdData?.NameEn) : item.OwnerIdData?.NameAr}</div>
                          <div>{item.OwnerIdData?.Runs}</div><div>{item.OwnerIdData?.wins}</div><div>{item.OwnerIdData?.second}</div><div>{item.OwnerIdData?.third}</div><div>{item.OwnerIdData?.fourth}</div><div>{item.OwnerIdData?.fifth}</div><div className="new-owner-bold-text">{t("AED")} {Number(item.OwnerIdData?.earning || 0).toLocaleString()}</div><div>{Number(item.OwnerIdData?.winspercentage || 0).toFixed(2)}</div><div>{Number(item.OwnerIdData?.placespercentage || 0).toFixed(2)}</div><div style={{ textAlign: 'right' }}><MdKeyboardArrowRight className="new-owner-acc-arrow-icon" /></div>                        </div>
                      </Accordion.Header>
                      {showBody === index && (
                        <Accordion.Body style={{ padding: 0 }}>
                          <ScrollContainer className="new-owner-inner-scroll-box" nativeMobileScroll={true}>
                            <div className="new-owner-inner-grid-table">
                              <div className="new-owner-inner-grid-header">
                                <div>{window.textTransform(t("Date"))}</div><div>{window.textTransform(t("Race No"))}</div><div>{window.textTransform(t("Crs"))}</div><div>{window.textTransform(t("Horse Name"))}</div><div>{window.textTransform(t("Dist"))}</div><div>{window.textTransform(t("RT"))}</div><div>{window.textTransform(t("Time"))}</div><div>{window.textTransform(t("Jockey"))}</div><div>{window.textTransform(t("Wgt"))}</div><div>{window.textTransform(t("Speed"))}</div><div>{window.textTransform(t("FP"))}</div><div>{window.textTransform(t("Len"))}</div><div>{window.textTransform(t("RN"))}</div><div>{window.textTransform(t("BtBy"))}</div><div>{window.textTransform(t("W Kgs"))}</div><div>{window.textTransform(t("Draw"))}</div><div>{window.textTransform(t("OR"))}</div><div></div>
                              </div>
                              <div className="new-owner-inner-grid-body">
                                {statusdata === "loading" ? <div className="new-owner-loader-inner"><Lottie animationData={Animate} style={{ width: '60px' }} /></div> : !Ownerrecord || Ownerrecord.length === 0 ? <div className="new-owner-no-history">{t("No History Yet")}</div> : (
                                  Ownerrecord.map((subItem, idx) => {
                                    const groundName = subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                    return (
                                      <div key={idx} className={`new-owner-inner-card-row ${groundName === "Dirt" ? 'row-dirt' : groundName === "Turf" ? 'row-turf' : 'row-default'}`}>
                                        <div onClick={() => handleShowRace(subItem.RaceID)} className="new-owner-link-text">{formatDateStandard(subItem.RaceResultData?.Day)}</div>
                                        <div>{subItem.RaceNumber || "-"}</div>
                                        <div>{cookiedata === "en" ? (subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.RaceCourseData?.AbbrevEn || "-") : (subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.RaceCourseData?.AbbrevAr || "-")} ({cookiedata === "en" ? groundName?.charAt(0) : subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameAr?.charAt(0)})</div>
                                        <div onClick={() => handleShowHorse(subItem.HorseIDData?._id)} className="new-owner-link-text">{cookiedata === "en" ? toTitleCase(subItem.HorseIDData?.NameEn) : subItem.HorseIDData?.NameAr}</div>
                                        <div>{subItem?.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.TrackLengthData?.TrackLength}</div>
                                        <div>{cookiedata === "en" ? toTitleCase(truncateRaceType(subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.RaceTypeModelData?.NameEn)) : subItem.RaceResultData?.RacehorsesData[0]?.RacehorsesData?.RaceTypeModelData?.NameAr}</div>
                                        <div>{subItem.RaceTime}</div>
                                        <div onClick={() => handleShowJockey(subItem?.JockeyOnRaceDataResult?._id)} className="new-owner-link-text">{cookiedata === "en" ? toTitleCase(subItem.JockeyOnRaceDataResult?.NameEn) : subItem.JockeyOnRaceDataResult?.NameAr}</div>
                                        <div>{subItem?.RaceResultData?.RacehorsesData[0]?.JockeyRaceWeight || 0}</div>
                                        <div>{typeof subItem.Speed === "number" ? subItem.Speed.toFixed(2) : "-"}</div>
                                        <div>{subItem.FinalPositionDataHorse === null ? "" : (cookiedata === "en" ? subItem.FinalPositionDataHorse.NameEn : subItem.FinalPositionDataHorse.NameAr)}</div>
                                        <div>{distanceLabel(subItem.Distance, subItem.FinalPositionDataHorse?.Rank)}</div>
                                        <div>{subItem.Runners}</div>
                                        <div onClick={() => handleShowHorse(subItem?.BeatenByData)} className="new-owner-link-text">{subItem.BeatenByData === null ? (cookiedata === "en" ? toTitleCase(subItem.HorseIDData?.HorseBeatenByEnglishName) : subItem.HorseIDData?.HorseBeatenByArabicName) : (cookiedata === "en" ? toTitleCase(subItem.BeatenByData?.NameEn) : subItem.BeatenByData?.NameAr)}</div>
                                        <div>{subItem.BeatenByData ? subItem.BeatenByData?.WinningHorseJockeyWeight : (subItem.HorseIDData?.BeatenByJockeyWeight || 0)}</div>
                                        <div>{subItem.RaceResultData?.RacehorsesData[0]?.HorseNo || "-"}</div>
                                        <div>{subItem.Rating || 0}</div>
                                        <div className="my-new-play-btn" onClick={() => handleShows(subItem.VideoLink)}>
                                          <IoMdPlay />
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                            </div>
                          </ScrollContainer>
                        </Accordion.Body>
                      )}
                    </Accordion.Item>
                  </Accordion>
                ))}
                <div className="new-owner-pagination-container"><Pagination postsPerPage={postsPerPage} totalPosts={totalcountdata} paginate={paginate} currentPage={currentPage} TotalPages={totalpagesdata} /></div>
              </>
            ) : <div className="new-owner-loader-main"><Lottie animationData={Animate} className="load1" style={{ marginTop: "30px" }} /></div>}
          </div>
        </div>

        <Modal show={show} onHide={handleClose} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><TrainerModal data={modaldata} /></Modal.Body></Modal>
        <Modal show={showJockey} onHide={handleCloseJockey} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><JockeyModal data={modaldataJockey} /></Modal.Body></Modal>

        <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
        <Modal show={showRace} onHide={handleCloseRace} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><RaceModal id={modaldataRace} /></Modal.Body></Modal>
        <Footer /><CoptRight />
      </div>
    </Fragment>
  );
}